import type { Node, Node_Type } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';

import { RICOS_NODE_TYPE_TO_DATA_FIELD } from '../consts.js';

export const isType = (type: Node_Type) => (node: Node) => node.type === type;

export const getDataFieldName = ({ type }: Node) => RICOS_NODE_TYPE_TO_DATA_FIELD[type];

export const getDataFieldValue = (node: Node) => {
  const dataFieldName = getDataFieldName(node);
  return dataFieldName && dataFieldName in node ? node[dataFieldName] : undefined;
};
